<style lang="scss" scoped>
  /*  /deep/ .ivu-table{
        background-color: hsla(0,0%,100%,.1)!important;
        td {
            background-color: #012c44;
            transition: background-color .2s ease-in-out;
            color: #08f4f7;
            border-bottom: 1px solid #258594;
        }
    }
    /deep/ .ivu-table-header thead tr th{
        border-color: rgba(8,244,247,.3)!important;
        background-color: hsla(0,0%,100%,.1);
        color: #08F4F7;
    }
*/
  /deep/ .ivu-modal-content {
      position: relative;
      background-color: #1c2b33;
      border: 0;
      border-radius: 6px;
      background-clip: padding-box;
      box-shadow: 0 4px 12px rgba(0,0,0,.15);
  }
    .expand-row {
        background: #012c44;
        color:#08F4F7;
        height: 47px;
        line-height: 47px;
        border-bottom: 1px solid #258594;
        text-align: center;
        text-align: center;
        .more {
            position: absolute;
            right: 30px;
            cursor: pointer;
            color: #08F4F7;
        }
    }
    .ivu-table th {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        background-color: #001A29;
        color: #08F4F7;
    }
    /deep/ .show-table {
        .ivu-modal-body {
            padding-top: 15px;
            .show-table-header {
                border-left: 2px solid #02e7e7;
                margin-left: 15px;
                padding-left: 10px;
                .table-header-desc {
                    font-size: 18px;
                    color: #02e7e7;
                }
                /deep/ .close-btn {
                    float: right;
                    margin-right: 20px;
                    border: 1px solid #08F4F7;
                    color: #08F4F7;
                    width: 56px;
                    height: 28px;
                    line-height: 28px;
                    cursor: pointer;
                    outline: none;
                    border-color: rgba(8,244,247,.3);
                    background-color: hsla(0,0%,100%,.1);
                }
            }
        }
        .ivu-modal-footer {
            border: none;
        }
    }
    .word {
        word-break: break-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
<template>
    <div>
        <Row class="expand-row" v-for="(item, index) of expandData" :key="index">
            <i-Col span="5">
                <span class="expand-key">{{ item.standardName }}</span>
            </i-Col>
            <i-Col span="5">
                <span class="expand-key">{{ timestampToTime(item.recordTime) }}</span>
            </i-Col>
            <i-Col span="5">
                <span class="expand-key">{{ item.patrolName }}</span>
            </i-Col>
            <i-Col span="4">
                <span class="expand-key word">{{ item.result }}</span>
            </i-Col>
            <i-Col span="5">
        <span class="expand-key">
          <img :src="dangerTrans(item.hiddenDanger)" alt>
        </span>
                <span class="more" v-if="index == expandData.length - 1" @click="getMore">更多</span>
            </i-Col>
        </Row>
        <span>{{a}}</span>
        <Modal
                v-model="modal"
                :closable="false"
                :footer-hiddle="true"
                width="1000"
                class-name="show-table"
        >
            <div class="show-table-header">
                <span class="table-header-desc">巡检项</span>
                <Button class="close-btn" type="primary" @click="modal = false;">返回</Button>
            </div>
            <privateTable
                    style="padding:0 15px"
                    class="m-t-20"
                    :columnsList="tableColumns"
                    :dataTable="dataTable"
                    @getPageData="getPageData"
                    @sizeChange="sizeChange"
            ></privateTable>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
    import getRandVal, {getTime} from '@/assets/js/index';
    import Base64 from '@/assets/js/base64.js';
    import md5 from 'js-md5';
    import {getDate} from '@/assets/js/tools';
    import privateTable from './private-table.vue';
    export default {
        props: {
            row: Object,
            deviceId:''
        },
        data() {
            return {
                a: '',
                limit: "1",
                modal: false,
                expandData: [],
                data: [],
                dataTable: {},
                tableColumns: [
                    {title: "巡检项名称", key: "standardName"},
                    {
                        title: "巡检时间",
                        key: "recordTime",
                        render: (h, params) => {
                            let arr = [
                                h(
                                    "span",
                                    {},
                                    `${this.timestampToTime(
                                        this.dataTable.list[params.index].recordTime
                                    )}`
                                )
                            ];
                            return h("div", arr);
                        }
                    },
                    {title: "巡检人", key: "patrolName"},
                    {
                        title: "巡检结果",
                        key: "result"
                    },
                    {
                        title: "是否警告",
                        key: "hiddenDanger",
                        render: (h, params) => {
                            let arr = [
                                h("img", {
                                    attrs: {
                                        src: `${this.dangerTrans(
                                            this.dataTable.list[params.index].hiddenDanger
                                        )}`
                                    }
                                })
                            ];
                            return h("div", arr);
                        }
                    }
                ],
                page: {
                    totalCount: 0,
                    pageSize: 5,
                    currentPage: 1
                }
            };
        },
        components: {
            privateTable
        },
        mounted() {
            this.getTwoData(this.limit);
        },
        methods: {
            //获取数据开始
            getPwdHash(pwd, data) {
                var sha = md5(pwd + data);
                var base = new Base64();
                var pwdHashStr = base.encode(sha);
                return pwdHashStr;
            },
            // 获取折线图数据
            getTwoData(limit) {
                let url='mcbw/patrol_records/values';
                var data = {
                    type: 'get',
                    url: url,
                    obj: {
                        deviceId:this.deviceId,
                        standardId: this.row["_id"],
                        pageSize: this.page.pageSize,
                        currentPage: this.page.currentPage,
                        limitStart: Number(limit)
                    }
                };
                this.$Axios(data).then((res) => {
                    if (res.data.success) {
                        if (res.data) {
                            if (this.limit) {
                                this.expandData = res.data.data;
                            } else {
                                this.data = res.data.data;
                                this.page.totalCount = res.data.totalCount;
                                this.dataTable = {
                                    list: this.data,
                                    page: this.page
                                };
                            }
                        }
                    }
                });
            },
            getPageData(val) {
                // 分页页数
                this.page.currentPage = val;
                this.getTwoData(this.limit);
            },
            sizeChange(val) {
                // 每页条数
                this.page.pageSize = val;
                this.getTwoData(this.limit);
            },
            getMore() {
                this.limit = null;
                this.page.pageSize = 10;
                this.getTwoData(this.limit);
                this.modal = true;
            },
            dangerTrans(val) {
                if (val == 1) {
                    return "http://gd-ca.oss-cn-beijing.aliyuncs.com/cdm/icon/baojing.png";
                } else if (val == 0) {
                    return "http://gd-ca.oss-cn-beijing.aliyuncs.com/cdm/icon/zhengchang.png";
                }
            },
            timestampToTime(timestamp) {
                // 转换时间戳
                if (timestamp == null) {
                    return "";
                } else {
                    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
                    var Y = date.getFullYear() + "-";
                    var M =
                        (date.getMonth() + 1 < 10
                            ? "0" + (date.getMonth() + 1)
                            : date.getMonth() + 1) + "-";
                    var D = date.getDate() + " ";
                    var h = date.getHours() + ":";
                    var m = date.getMinutes() + ":";
                    var s = date.getSeconds();
                    return Y + M + D + h + m + s;
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/riskRecord/table-expand.vue